module.exports = window.G6;